<app-modal class="confirm-share-container">
    <mat-chip-list>
        <mat-chip *ngFor="let email of data.emails">
            {{ email }}
        </mat-chip>
    </mat-chip-list>
</app-modal>
